import { render, staticRenderFns } from "./BottomNavBar.vue?vue&type=template&id=56e4d15f&scoped=true"
import script from "./BottomNavBar.vue?vue&type=script&lang=js"
export * from "./BottomNavBar.vue?vue&type=script&lang=js"
import style0 from "./BottomNavBar.vue?vue&type=style&index=0&id=56e4d15f&prod&lang=scss"
import style1 from "./BottomNavBar.vue?vue&type=style&index=1&id=56e4d15f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56e4d15f",
  null
  
)

export default component.exports